import toKebabCase from 'utils/toKebabCase';

const getRandomId = (prefix: string | number): string => `${toKebabCase(`${prefix}`)}-${Date.now()}`;

export default getRandomId;
